module.exports = __webpack_public_path__ + "static/img/icon_jinhua_ssr@2x.fbcfb721.png";